<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>Contents</h1><ol><li id="level1-titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></li>
<li id="level1-toc"><a href="#/toc">Contents</a></li>
<li id="level1-front3"><a href="#/front01">Copyright</a></li>
<li id="level1-front4"><a href="#/front02">Dedication</a></li>
<li id="level1-front5"><a href="#/front03">Epigraph</a></li>
<li id="c01"><a href="#/c01">Silencer to the Heart While Jogging Through a Park</a>
</li>
<li id="c02"><span href="#/c02" title="Link target outside of Sample">Conjecture on the Stained-Glass Image of White Christ at Ebenezer Baptist Church</span>
</li>
<li id="c03"><span href="#/c03" title="Link target outside of Sample">In My 31st Year</span>
</li>
<li id="c04"><span href="#/c04" title="Link target outside of Sample">Taking Aim at a Macy’s Changing Room Mirror, I Blame Television</span>
</li>
<li id="c05"><span href="#/c05" title="Link target outside of Sample">In Defense of Ballin’ on a Budget</span>
</li>
<li id="c06"><span href="#/c06" title="Link target outside of Sample">Watch Us Elocute</span>
</li>
<li id="c07"><span href="#/c07" title="Link target outside of Sample">Ars Poetica Battle Rhyme for <em>Really</em> Wannabe Somebodies</span>
</li>
<li id="c08"><span href="#/c08" title="Link target outside of Sample">Prayer on Aladdin’s Lamp</span>
</li>
<li id="c09"><span href="#/c09" title="Link target outside of Sample">Plea to My Jealous Heart</span>
</li>
<li id="c10"><span href="#/c10" title="Link target outside of Sample">Confessional Booth with Lines from Heartbreak “Drizzy” Drake, Ending on a Theme from Oddisee</span>
</li>
<li id="c11"><span href="#/c11" title="Link target outside of Sample">Ode to Browsing the Web</span>
</li>
<li id="c12"><span href="#/c12" title="Link target outside of Sample">Stumped Speech on the Internet</span>
</li>
<li id="c13"><span href="#/c13" title="Link target outside of Sample">Close Encounters</span>
</li>
<li id="c14"><span href="#/c14" title="Link target outside of Sample">Creation Song in Which a Swift Wind Sucker-Punches a Transformer</span>
</li>
<li id="c15"><span href="#/c15" title="Link target outside of Sample">Silencer on the Arrest of Professor Henry Louis Gates Jr. After Sassing an Officer Who Assumed He’d Unlawfully Entered His Own Home</span>
</li>
<li id="c16"><span href="#/c16" title="Link target outside of Sample">Silencer with Blues &amp; Birds on a Wire</span>
</li>
<li id="c17"><span href="#/c17" title="Link target outside of Sample">The Trees</span>
</li>
<li id="c18"><span href="#/c18" title="Link target outside of Sample">Blue Faces</span>
</li>
<li id="c19"><span href="#/c19" title="Link target outside of Sample">Theorizing Wesley: On the African American Nonresident Alien</span>
</li>
<li id="c20"><span href="#/c20" title="Link target outside of Sample">Film Noir at Gallup Park, On the Edge</span>
</li>
<li id="c001"><span href="#/c001" title="Link target outside of Sample">⦿</span>
<ol>
<li id="c21"><span href="#/c21" title="Link target outside of Sample">When I’m alone in my room sometimes I stare at the wall, &amp; in the back of my mind I hear my conscience call</span></li>
<li id="c22"><span href="#/c22" title="Link target outside of Sample">The Way We Were Made</span></li>
<li id="c23"><span href="#/c23" title="Link target outside of Sample">Incident with Nature, Late</span></li>
<li id="c24"><span href="#/c24" title="Link target outside of Sample">Shibboleth</span></li>
<li id="c25"><span href="#/c25" title="Link target outside of Sample">When academia tells me only a fool believes in a God that he can’t see</span></li>
<li id="c26"><span href="#/c26" title="Link target outside of Sample">On Being Told Prayer Is a Crutch</span></li>
<li id="c27"><span href="#/c27" title="Link target outside of Sample">Deer Ode, Tangled &amp; Horned</span></li>
<li id="c28"><span href="#/c28" title="Link target outside of Sample">Nocturne with Revelations &amp; Militant Black Jesus</span></li>
<li id="c29"><span href="#/c29" title="Link target outside of Sample">Ars Poetica</span></li>
</ol>
</li>
<li id="c002"><span href="#/c002" title="Link target outside of Sample">⦿</span>
<ol>
<li id="c30"><span href="#/c30" title="Link target outside of Sample">The Most Dangerous Game</span></li>
<li id="c31"><span href="#/c31" title="Link target outside of Sample">Animal Farm</span></li>
</ol>
</li>
<li id="c003"><span href="#/c003" title="Link target outside of Sample">Cul-de-sac Pastoral</span>
<ol>
<li id="c32"><span href="#/c32" title="Link target outside of Sample">Ars Poetica Battle Rhyme for Sucker Emcees</span></li>
<li id="c33"><span href="#/c33" title="Link target outside of Sample">Bay Window Lauds</span></li>
<li id="c34"><span href="#/c34" title="Link target outside of Sample">Weekend Open House Sext</span></li>
<li id="c35"><span href="#/c35" title="Link target outside of Sample">Tiki Torch Cookout Vespers</span></li>
<li id="c36"><span href="#/c36" title="Link target outside of Sample">Trash Night Compline</span></li>
<li id="c37"><span href="#/c37" title="Link target outside of Sample">Materialist Matins</span></li>
<li id="c38"><span href="#/c38" title="Link target outside of Sample">Prayer on the Subdivision</span></li>
<li id="c39"><span href="#/c39" title="Link target outside of Sample">Conjecture on the Dream</span></li>
<li id="c40"><span href="#/c40" title="Link target outside of Sample">Morning in the Burbs</span></li>
</ol>
</li>
<li id="level1-back78"><span href="#/back01" title="Link target outside of Sample">Acknowledgments</span></li>
<li id="level1-back79"><span href="#/back02" title="Link target outside of Sample">About the Author</span></li>
<li id="level1-back80"><span href="#/back03" title="Link target outside of Sample">Connect with HMH</span></li></ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5a8ae8a8